"use client";

import { useEffect, useRef } from "react";
import { useSearchParams } from "next/navigation";

/**
 * Tiny client island that scrolls to the top of the page when the
 * pagination page changes. Renders nothing visible.
 */
export default function ScrollToTop({ page }: { page: number }) {
    const searchParams = useSearchParams();
    const previousPageRef = useRef(page);

    useEffect(() => {
        const urlPageParam = searchParams.get("page");
        const urlPage = urlPageParam ? parseInt(urlPageParam, 10) : 1;
        const effectivePage = page || urlPage;

        if (effectivePage !== previousPageRef.current) {
            previousPageRef.current = effectivePage;

            const scrollTimeout = setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }, 100);

            return () => clearTimeout(scrollTimeout);
        }

        return undefined;
    }, [page, searchParams]);

    return null;
}
